import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../base_url';
import { PuffLoader } from 'react-spinners';
import { Pagination } from '@mui/material';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const UpdateIMEI = () => {
    const [loading, setLoading] = useState(false);
    const [imei, setImei] = useState('');
    const [vin, setVin] = useState('');
    const [location, setLocation] = useState('');
    const locations = ['YYZ', 'LAX', 'JFK', 'ORD']; 

    const handleSave = async () => {
        if (!imei || !vin || !location) {
            Swal.fire('Validation Error', 'Please fill all fields', 'warning');
            return;
        }

        try {
            setLoading(true);

            await axios.post(`${baseURL}/save-imei-vin`, {
                imei,
                vin,
                location
            });

            Swal.fire('Success', 'Data saved successfully', 'success');

            // Reset form
            setImei('');
            setVin('');
            setLocation('');

        } catch (error) {
            Swal.fire(
                'Error',
                error?.response?.data?.message || 'Something went wrong',
                'error'
            );
        } finally {
            setLoading(false);
        }
    };

  return(
    <div className='body_class'>
      {loading ? (
          <div className="loader-overlay">
              <div className="loader">
              <PuffLoader color="#00308F" loading={true} size={200} />
              </div>
          </div>
      ) : ("")}
        <div className='container-fluid'>
            <h4>Update IMEI and VIN</h4>
            <div className='mt-4 col-6'>
              {/* IMEI */}
                <div className='row mb-3 align-items-center'>
                    <label className='col-3 col-form-label fw-semibold'>
                        IMEI
                    </label>
                    <div className='col-9'>
                        <input
                            type='text'
                            className='form-control'
                            value={imei}
                            onChange={(e) => setImei(e.target.value)}
                            placeholder='Enter IMEI'
                        />
                    </div>
                </div>

                {/* VIN */}
                <div className='row mb-3 align-items-center'>
                    <label className='col-3 col-form-label fw-semibold'>
                        VIN
                    </label>
                    <div className='col-9'>
                        <input
                            type='text'
                            className='form-control'
                            value={vin}
                            onChange={(e) => setVin(e.target.value)}
                            placeholder='Enter VIN'
                        />
                    </div>
                </div>

                {/* Location */}
                <div className='row mb-3 align-items-center'>
                    <label className='col-3 col-form-label fw-semibold'>
                        Location
                    </label>
                    <div className='col-9'>
                        <select
                            className='form-select'
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                        >
                            <option value=''>Select Location</option>
                            {locations.map(loc => (
                                <option key={loc} value={loc}>{loc}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Save Button */}
                <div className='row'>
                    <div className='col-3'></div>
                    <div className='col-9'>
                        <button
                            className='btn btn-primary'
                            onClick={handleSave}
                            disabled={loading}
                        >
                            Save
                        </button>
                    </div>
                    <div className='col-9'>
                        <button
                            className='btn btn-secondary'
                            type='button'
                            onClick={() => {
                                setImei('');
                                setVin('');
                                setLocation('');
                            }}
                            disabled={loading}
                        >
                            Clear
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )  
}

export default UpdateIMEI;